export const CategoryTree = {
    template: '#category-tree-template',
    props: {
        tree: {
            type: Array
        },
        initSelected: {}
    },
    emits: ['filterByIcsGroup'],
    data: function () {
        return {
            selected: {}
        }
    },
    created: function () {
        this.selected = this.initSelected;
    },
    computed: {
        path: function () {
            var pathCandidate = [];
            var self = this;

            if (!this.selected)
                return [];

            var buildPathToSelected = function (categories) {
                for (let categoryIndex in categories) {
                    pathCandidate.push(categories[categoryIndex]);
                    if (categories[categoryIndex].value == self.selected.value) {
                        return true;
                    }
                    if (categories[categoryIndex].children.length == 0) {
                        pathCandidate.pop();
                        continue;
                    }
                    if (buildPathToSelected(categories[categoryIndex].children) == true) {
                        return true;
                    }
                    pathCandidate.pop();
                }

                return false;

            };
            buildPathToSelected(this.tree);
            return pathCandidate;
        },
        selectedCategoryChildren: function () {
            if (!this.selected) {
                return this.tree;
            }

            if (this.path.length == 0) {
                return this.tree;
            }
            return this.path[this.path.length - 1].children;
        }
    },
    methods: {
        setSelected: function (category) {
            if (category == null || category == undefined) {
                this.selected = null;
            }
            this.selected = category;
        },
        clearSelected: function () {
            this.selected = null
        }
    },
    watch: {
        selected: {
            handler: function (o, n) {
                this.$emit('filterByIcsGroup', this.selected)
            }
        }
    }
};
